class ThemeSwiperBreakpoint extends HTMLElement {
  options = {}; width;

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.options = {};
    this.width = parseInt(this.dataset.breakpoint);
    this.setSlides(this.dataset.slides);
    this.setSpaceBetween(this.dataset.spaceBetween);
    this.setSlideGroups(this.dataset.slideGroups);
  }

  getOptions = () => {
    return this.options;
  }

  setSpaceBetween = (spaceBetween) => {
    const s = parseInt(spaceBetween);
    if(!isNaN(s)){
      this.options.spaceBetween = s;
    }
  }  

  setSlideGroups = (slideGroups) => {
    const s = parseInt(slideGroups);
    if(!isNaN(s)){
      this.options.slidesPerGroup = s;
    }
  }  

  setSlides = (slides) => {
    if(slides != undefined){
      this.options.slidesPerView = slides;
    }
  } 
}
if (!window.customElements.get("theme-swiper-breakpoint")) {
  window.customElements.define("theme-swiper-breakpoint", ThemeSwiperBreakpoint);
}
class ThemeSwiper extends HTMLElement {
  options; swiper;
  paginationSelector = '.swiper-pagination';
  navigationPrev = '.swiper-button-prev';
  navigationNext = '.swiper-button-next';
  scrollbarSelector = '.swiper-scrollbar';

  constructor() {
    super();
    if(this.dataset.noinit === undefined || this.dataset.noinit === 'false')
      this.init();
  }

  init = () => {
    // Inizializza un nuovo oggetto opzioni vuoto
    this.options = {};
    // Usa i selector personalizzati dai data attributes o fallback a quelli di default
    this.paginationSelector = this.dataset.paginationSelector || this.paginationSelector;
    this.navigationPrev = this.dataset.navigationPrev || this.navigationPrev;
    this.navigationNext = this.dataset.navigationNext || this.navigationNext;
    this.scrollbarSelector = this.dataset.scrollbarSelector || this.scrollbarSelector;

    // Chiama tutti i setter per costruire l'oggetto opzioni in base ai data attributes
    // Ogni setter valida i dati e aggiunge solo le opzioni configurate al'oggetto
    this.setNavigation(this.dataset.navigation !== undefined && this.dataset.navigation !== 'false');
    this.setPagination(this.dataset.pagination !== undefined && this.dataset.pagination !== 'false');
    this.setDynamicBullets(this.dataset.dynamicBullets !== undefined && this.dataset.dynamicBullets !== 'false');
    this.setPaginationType(this.dataset.paginationType);
    this.setScrollbar(this.dataset.scrollbar !== undefined && this.dataset.scrollbar !== 'false');
    this.setMousewheel(this.dataset.mousewheel !== undefined && this.dataset.mousewheel !== 'false');
    this.setScrollbarHide(this.dataset.scrollbarHide !== undefined && this.dataset.scrollbarHide !== 'false');
    this.setDirection(this.dataset.direction);
    this.setSpaceBetween(this.dataset.spaceBetween);
    this.setSlides(this.dataset.slides);
    this.setCentered(this.dataset.centered !== undefined && this.dataset.centered !== 'false');
    this.setFree(this.dataset.free !== undefined && this.dataset.free !== 'false');
    this.setLoop(this.dataset.loop !== undefined && this.dataset.loop !== 'false');
    this.setAutoplay(this.dataset.autoplay);
    this.setEffect(this.dataset.effect);
    this.setWatchProgress(this.dataset.watchProgress !== undefined && this.dataset.watchProgress !== 'false');
    this.setThumbs(this.dataset.thumbs);
    this.setSlideGroups(this.dataset.slideGroups);
    // Estrae le opzioni dai breakpoint child elements e le aggiunge
    this.setBreakpoints();

    // Accessibilità carosello: traccia le slide realmente visibili (swiper-slide-visible)
    // e nasconde alle AT/tastiera solo quelle fuori vista (vedi updateAriaHidden)
    this.options.watchSlidesProgress = true;
    this.options.on = {
      ...this.options.on,
      init: (swiper) => this.updateAriaHidden(swiper),
      slideChange: (swiper) => this.updateAriaHidden(swiper),
      resize: (swiper) => this.updateAriaHidden(swiper),
      slidesUpdated: (swiper) => this.updateAriaHidden(swiper)
    };

    // Infine crea l'istanza di Swiper con le opzioni accumulate
    this.swiper = new Swiper(this, this.options);
  }

  // Nasconde alle AT/tastiera solo le slide NON visibili. Usa la classe 'swiper-slide-visible'
  // (richiede watchSlidesProgress) cosi i caroselli con piu slide visibili — es. le pills delle
  // collezioni — restano completamente operabili da tastiera.
  updateAriaHidden = (swiper) => {
    swiper.slides.forEach((slide) => {
      const isVisible = slide.classList.contains('swiper-slide-visible');
      slide.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      // inert: rende l'intera slide fuori vista non focalizzabile e fuori dall'albero a11y
      // in modo robusto, anche con elementi annidati (es. swiper gallery dentro la product-card)
      // che sfuggirebbero al toggle manuale dei tabindex → evita aria-hidden-focus.
      slide.inert = !isVisible;
      slide.querySelectorAll('a, button, video, [tabindex]').forEach(el => {
        // Fallback per browser senza supporto inert + non rendere focalizzabili gli elementi
        // aria-hidden (es. link-immagine duplicato della product-card).
        if (el.getAttribute('aria-hidden') === 'true') {
          el.setAttribute('tabindex', '-1');
          return;
        }
        el.setAttribute('tabindex', isVisible ? '0' : '-1');
      });
    });
  }

// ✅ Consigliato
setOptions = (options) => {
    this.options = options;
    this.options.watchSlidesProgress = true;
    this.options.on = {
      ...this.options.on,
      init: (swiper) => this.updateAriaHidden(swiper),
      slideChange: (swiper) => this.updateAriaHidden(swiper),
      resize: (swiper) => this.updateAriaHidden(swiper),
      slidesUpdated: (swiper) => this.updateAriaHidden(swiper)
    };
    this.swiper = new Swiper(this, this.options);
}

  setSlideGroups = (slideGroups) => {
    const s = parseInt(slideGroups);
    if(!isNaN(s)){
      this.options.slidesPerGroup = s;
    }
  }  

  setNavigation = (navigation) => {
    if(navigation) {
      this.options.navigation = {
        nextEl: this.navigationNext,
        prevEl: this.navigationPrev
      }
    } 
  }

  setPagination = (pagination) => {
    if(pagination) {
      this.options.pagination = {
        el: this.paginationSelector,
        clickable: true
      }
    } 
  }

  setDynamicBullets = (dynamicBullets) => {
    if(dynamicBullets) {
      this.options.pagination = this.options.pagination || {};
      this.options.pagination.dynamicBullets = true;
    } 
  }

  setPaginationType = (type) => {
    if(type != undefined){
      this.options.pagination = this.options.pagination || {};
      this.options.pagination.type = type;
    }
  }  

  setScrollbar = (scrollbar) => {
    if(scrollbar) {
      this.options.scrollbar = {
        el: this.scrollbarSelector,
      }
    } 
  }

  setScrollbarHide = (hide) => {
    if(hide) {
      this.options.scrollbar = this.options.scrollbar || {};
      this.options.scrollbar.hide = true;
    } 
  }

  setEffect = (effect) => {
    if(effect != undefined){
      this.options.effect = effect;
    }
  }  

  setDirection = (direction) => {
    if(direction != undefined){
      this.options.direction = direction;
    }
  }  

  setSpaceBetween = (spaceBetween) => {
    const s = parseInt(spaceBetween);
    if(!isNaN(s)){
      this.options.spaceBetween = s;
    }
  }  

  setSlides = (slides) => {
    if(slides != undefined){
      this.options.slidesPerView = slides;
    }
  } 

  setCentered = (centered) => {
    if(centered) {
      this.options.centeredSlides = true;
    } 
  }

  setMousewheel = (mousewheel) => {
    if(mousewheel) {
      this.options.mousewheel = true;
    } 
  }

  setFree = (free) => {
    if(free) {
      this.options.freeMode = true;
    } 
  }

  setLoop = (loop) => {
    if(loop) {
      this.options.loop = true;
    } 
  }

  setAutoplay = (autoplay) => {
    const s = parseInt(autoplay);
    if(!isNaN(s)){
      this.options.autoplay = {
        delay: s
      };
    }
  }  

  setWatchProgress = (watchProgress) => {
    if(watchProgress) {
      this.options.watchSlidesProgress = true;
    } 
  }

  setThumbs = (selector) => {
    const thumbs = document.querySelector(selector);
    if(thumbs != undefined && thumbs != null){
      this.options.thumbs = {
        swiper: thumbs
      };
    }
  } 

  setBreakpoints = () => {
    // Raccoglie tutte le opzioni configurate per ogni breakpoint
    // I breakpoint sono definiti come elementi child "theme-swiper-breakpoint"
    // che contengono le opzioni specifiche per una determinata larghezza di schermo
    const breakpoints = this.querySelectorAll('theme-swiper-breakpoint');
    if(breakpoints.length > 0){
      this.options.breakpoints = {};
      breakpoints.forEach(breakpoint => {
        // Chiama getOptions() su ogni elemento per estrarre le sue opzioni accumulate
        if (typeof breakpoint.getOptions === 'function') {
          // Usa la larghezza del breakpoint come chiave per le opzioni Swiper
          this.options.breakpoints[breakpoint.width] = breakpoint.getOptions();
        } else {
          console.error('getOptions method not found for', breakpoint);
        }
      });
    }
  }

}
if (!window.customElements.get("theme-swiper")) {
  window.customElements.define("theme-swiper", ThemeSwiper);
}
